module.exports = __webpack_public_path__ + "img/videoPaly.e0b454d2.svg";